export default __webpack_public_path__ + "static/media/cancel.a47d8e58.svg";